module.exports = __webpack_public_path__ + "static/media/teamwork5-1.d329c36a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/AboutUs/image/teamwork5-1.jpg
// module id = 436
// module chunks = 0